function NotFound() {
  return (
    <div className='h-100vh flex items-center justify-center'>
      <h1 className='fs-3xl'>404 Not Found</h1>
    </div>
  );
}

export default NotFound;
